// eslint-disable-next-line no-restricted-imports
import { LegalClientLegalAddressFragment } from 'api/generated/graphql';
import { LegalClientLegalAddressEntity } from 'api/types/entity';
import { lodash } from 'helpers';
import { Maybe } from 'types/maybe';

import { parseFileEntity } from '../../helpers';

export const parseLegalClientLegalAddressEntity = (
  data?: Maybe<LegalClientLegalAddressFragment>
): LegalClientLegalAddressEntity | undefined => {
  if (!data) {
    return undefined;
  }

  const { confirmationFiles, ...rest } = data;

  const res: LegalClientLegalAddressEntity = {
    ...rest,
    confirmationFiles: lodash.compact(confirmationFiles).map(parseFileEntity),
  };

  return res;
};
